<template>
  <div class="page-container">
    <div class="search-wrapper">
      <Row class="margin-left-16 box-title-mt-32">
        <Col span="18">
          <Form class="content-right-box" :label-width="150">
            <FormItem label="是否开启位置打卡:">
              <i-switch v-model="switchSignPlace" @on-change="putSignPlace"></i-switch>
            </FormItem>
            <p class="tips">①开启后，教师需要指定的位置范围内才可正常打卡，否则无法进行教师考勤。</p>
          </Form>
        </Col>
      </Row>
      <div style="margin-top:16px">
        <Button type="primary" @click="handleToAddLocation">添加打卡位置</Button>
      </div>
      <Row class="margin-left-16 box-title-mt-32">
        <Col span="18">
          <Table
            border
            :columns="tableColumns"
            :data="tableData"
            :loading="loading"
          >
            <template slot="efficientRange" slot-scope="{ row }">
              {{ row.efficientRange | radiusShow }}
            </template>
            <template slot="action" slot-scope="{ row }">
              <span class="click-btn-430" @click="handleEditPoint(row)">修改</span>
              <span class="click-btn-430" @click="handleDelelList(row.pointId)">删除</span>
            </template>
          </Table>
        </Col>
      </Row>
    </div>
    <Modal
      v-model="modalShow"
      :width="800"
      :title="modeStr"
      :footer-hide="true"
    >
      <Form ref="placeInfo" :rules="ruleValidate" :model="placeInfo" class="form-box" :label-width="150" inline>
        <Row>
          <FormItem label="考勤地点名称:" prop="orgAliasName">
            <Input
              v-model="placeInfo.orgAliasName"
              placeholder="请填写"
              style="width:220px"
            ></Input>
          </FormItem>
        </Row>
        <Row>
          <Col :span="8">
            <FormItem label="考勤地点(经度):" prop="longitude">
              <div style="width:180px"><span>{{ placeInfo.longitude || '--' }}</span></div>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="考勤地点(纬度):" prop="latitude">
              <div style="width:180px"><span>{{ placeInfo.latitude || '--' }}</span></div>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <p class="tips" style="margin-left:120px">提示：地点的经纬度可以通过点击<span class="click-btn-430" @click="handleShowLocation">这里</span>来获取。</p>
        </Row>
        <Row>
          <FormItem label="考勤有效范围:" prop="efficientRange">
            <Select v-model="placeInfo.efficientRange" style="width:200px">
              <Option v-for="item in rangeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
            <span>（米）</span>
            <span class="click-btn-430" @click="handleOpenExample">示例</span>
          </FormItem>
        </Row>
      </Form>
      <p class="tips">①考勤地点名称需唯一，不可重复</p>
      <p class="tips">②经纬度需设置精准的坐标位置</p>
      <p class="tips">③有可能受手机GPS定位信号弱影响，不在有效考勤范围的老师将无法打卡。</p>
      <div class="modal-btnbox">
        <Button @click="handleCancelModal">取消</Button>
        <Button type="primary" @click="handleSubmitLocation">确定</Button>
      </div>
    </Modal>
    <LocationMapDrawer ref="locationMapDrawer" @getLocation="getSelectLocation"></LocationMapDrawer>
    <Modal
      v-model="exampleShow"
      :width="450"
      title="查看示例"
      :footer-hide="true"
    >
      <div class="demo-carousel">
        <img :src="locationExample" alt="">
      </div>
    </Modal>
  </div>
</template>
<script>
import LocationMapDrawer from '@c/Base/LocationMapDrawer.vue';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
export default {
  components: {
    LocationMapDrawer
  },
  filters: {
    radiusShow(radius) {
      if (+radius) {
        return radius * 100;
      } else {
        return radius;
      }
    }
  },
  props: {
    orgId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateOrgAliasName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入考勤地点名称'));
      } else if (this.mode === 'add') {
        const index = this.tableData.findIndex(item => {
          return item.orgAliasName === value;
        });
        index === -1 ? callback() : callback(new Error('该考勤地点名称已存在'));
      } else {
        const index = this.tableData.findIndex(item => {
          return item.orgAliasName === value;
        });
        const pointId = index === -1 ? '' : this.tableData[index].pointId;
        (index === -1 || pointId === this.selectPointId) ? callback() : callback(new Error('该考勤地点名称已存在'));
      }
    };
    return {
      // switchSignPlace: false,
      tableData: [],
      loading: false,
      tableColumns: [
        {
          title: '地点名称',
          key: 'orgAliasName',
          align: 'center'
        },
        {
          title: '有效范围（米）',
          slot: 'efficientRange',
          align: 'center'
        }, {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ],
      modalShow: false,
      placeInfo: {
        orgAliasName: '', // 考勤地点
        longitude: '',
        latitude: '',
        efficientRange: '',
        address: ''
      },
      selectPointId: '', // 地点的id
      rangeList: [
        {
          name: '100',
          value: '1'
        },
        {
          name: '200',
          value: '2'
        },
        {
          name: '300',
          value: '3'
        },
        {
          name: '400',
          value: '4'
        }, {
          name: '500',
          value: '5'
        }, {
          name: '600',
          value: '6'
        }, {
          name: '700',
          value: '7'
        }, {
          name: '800',
          value: '8'
        }, {
          name: '900',
          value: '9'
        }, {
          name: '1000',
          value: '10'
        }
      ],
      locationExample: require('@/assets/img/loction_example.png'),
      exampleShow: false,
      ruleValidate: {
        orgAliasName: [
          { required: true, validator: validateOrgAliasName, trigger: 'blur' }
        ],
        longitude: [
          { required: true, type: 'number', message: '请先定位经纬度', trigger: 'blur' }
        ],
        latitude: [
          { required: true, type: 'number', message: '请先定位经纬度', trigger: 'blur' }
        ],
        efficientRange: [
          { required: true, message: '请选择考勤有效范围', trigger: 'change' }
        ]
      },
      mode: 'add' // add 添加 edit 修改
    };
  },
  computed: {
    switchSignPlace: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }, // 课程信息
    modeStr() {
      if (this.mode === 'add') {
        return '添加考勤地点';
      } else if (this.mode === 'edit') {
        return '修改考勤地点';
      } else {
        return '';
      }
    }
  },
  created() {
    this.getLocationList();
  },
  methods: {
    async getLocationList() {
      const params = {
        orgId: this.orgId
      };
      const res = await courseCenterApi.getSysSignPointListApi(params);
      if (res.status === 200) {
        this.tableData = res.message;
      }
    },
    // 是否开启教师位置打卡
    async putSignPlace(status) {
      const params = {
        orgId: this.orgId, // 学校id
        param: status ? 1 : 2// 1开启 2不开启
      };
      try {
        this.$Spin.show();
        const res = await courseCenterApi.postSignPlaceApi(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('保存成功');
        }
      } catch (err) {
        this.$Spin.hide();
        console.log('err', err);
      }
    },
    // 添加考勤地点
    handleToAddLocation() {
      this.$refs.placeInfo.resetFields();
      this.mode = 'add';
      this.modalShow = true;
    },
    handleShowLocation() {
      let point = null;
      if (this.mode === 'edit') {
        point = {
          lng: this.placeInfo.longitude,
          lat: this.placeInfo.latitude,
          address: this.placeInfo.address
        };
      }
      this.$nextTick(() => {
        this.$refs.locationMapDrawer.openDrawer(point);
      });
    },
    getSelectLocation(location) {
      const { lat, lng, address, title } = location;
      this.placeInfo.latitude = lat;
      this.placeInfo.longitude = lng;
      this.placeInfo.address = address;
      this.$refs.placeInfo.validateField('longitude');
      this.$refs.placeInfo.validateField('latitude');
    },
    // 展示示例
    handleOpenExample() {
      this.exampleShow = true;
    },
    handleCancelModal() {
      this.modalShow = false;
    },
    handleSubmitLocation() {
      this.$refs.placeInfo.validate((valid) => {
        if (valid) {
          this.mode === 'edit' ? this.editLocationInfo() : this.addLocation();
        }
      });
    },
    async addLocation() {
      const { orgAliasName, efficientRange, address, ...point } = this.placeInfo;
      const params = {
        orgAliasName,
        efficientRange,
        point: JSON.stringify(point),
        orgId: this.orgId,
        address
      };
      const res = await courseCenterApi.addSysSignPointApi(params);
      if (res.status === 200) {
        this.$Message.success('添加成功');
        this.getLocationList();
        this.modalShow = false;
      }
    },
    async editLocationInfo() {
      const { orgAliasName, efficientRange, ...point } = this.placeInfo;
      const params = {
        orgAliasName,
        efficientRange,
        point: JSON.stringify(point),
        pointId: this.selectPointId,
        address: orgAliasName
      };
      const res = await courseCenterApi.updateSysSignPointApi(params);
      if (res.status === 200) {
        this.$Message.success('修改成功');
        this.getLocationList();
        this.modalShow = false;
      }
    },
    // 删除地点
    handleDelelList(pointId) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>您确定删除该考勤地点吗？</p>',
        onOk: () => {
          this.delListPoint(pointId);
        }
      });
    },
    async delListPoint(pointId) {
      const params = {
        pointId
      };
      const res = await courseCenterApi.delSysSignPointApi(params);
      if (res.status === 200) {
        this.$Message.success('删除成功');
        this.getLocationList();
      }
    },
    // 修改
    handleEditPoint(row) {
      this.mode = 'edit';
      const { longitude, latitude } = JSON.parse(row.point);
      this.placeInfo = {
        orgAliasName: row.orgAliasName, // 考勤地点
        longitude,
        latitude,
        efficientRange: row.efficientRange + '',
        address: row.address
      };
      this.selectPointId = row.pointId;
      this.$nextTick(() => {
        this.modalShow = true;
        // this.$refs.locationMapDrawer.openDrawer({ lng: longitude, lat: latitude });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.location-content{
  width: 100%;
}
.modal-btnbox{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 32px;
  button+button{
    margin-left: 16px;
  }
}
.tips{
  color: #999;
  margin: 8px 0;
}

.demo-carousel {
    width: 400px;
    height: 400px;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  // .form-box{
  //   width: 100%;
  //   /deep/.ivu-row{
  //     width: 100%;
  //   }
  // }
</style>
